// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__2T93I","buttons":"Text_buttons__aO0Xz"};